export default "__VITE_ASSET__BGM229b4__"